import React from 'react';

const DeleteOverlay = ({ isVisible, message = "Deleting classes - won't be a moment" }) => {
  if (!isVisible) return null;

  return (
    <div className="delete-loading-backdrop">
      {/* Enhanced backdrop with better visibility */}
      <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-md"></div>
      
      {/* Improved loading content with better styling */}
      <div className="delete-loading-content relative bg-white dark:bg-gray-800 rounded-xl shadow-2xl p-8 max-w-md mx-4 border border-gray-200 dark:border-gray-700">
        <div className="flex flex-col items-center space-y-6">
          {/* Enhanced spinner with pulsing effect */}
          <div className="relative">
            <div className="animate-spin rounded-full h-16 w-16 border-4 border-gray-200 dark:border-gray-600"></div>
            <div className="animate-spin rounded-full h-16 w-16 border-4 border-red-500 border-t-transparent absolute top-0 left-0"></div>
          </div>
          
          {/* Enhanced message with better typography */}
          <div className="text-center">
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
              Deleting Classes
            </h3>
            <p className="text-gray-600 dark:text-gray-300 text-base leading-relaxed">
              {message}
            </p>
            <div className="mt-4 flex justify-center">
              <div className="flex space-x-1">
                <div className="w-2 h-2 bg-red-500 rounded-full animate-bounce"></div>
                <div className="w-2 h-2 bg-red-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                <div className="w-2 h-2 bg-red-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteOverlay;
